import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'
import { BasicSelect } from 'vue-search-select';
import keycloak from '../../../../common/Keycloak';

export default {
  name: 'UploadScanPODSheet',
  components: {
      VueElementLoading,
      Paginate,
      BasicSelect
  },
  mixins:[PageTracker],
  data: function() {
      return {
        fileTypeArray:['Delivery','WHHandover','DTOWHHandover'],
        shipmentTypeList : [],
        shipmentType : '',
        fileType : '',
        file : '',
        userID : '',
        users:[],
        dateobj : {
          toDate : ''
        },
        hubServiceCenterList : [],
        searchFlag:false,
        BatchArray:[],
        AssignBatchVal : '',
        NoBatchFlag:false,
        localuserid : '',
        localusermailid : '',
        rolename : '',
        hubname : '',
        video: {},
        canvas: [],
        captures: [],
        isCapture : false,
        isVideo:true,
        localusermailid:'',
        userObj: {},
        AttachmentPageNo: '',
        srLoader :'',
        loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
        SearchLoading: false,
        uploadLoader: false,
        userDataKey : '',
        userRolesFE : []
      }
  },
  created: function() {
  //this.changeDateFormat();
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    console.log('userdetail',userdetail);

    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.userRolesFE = userdetail.userroleFE;
    this.hubname = userdetail.hubdetails[0];
    this.localuseroutsourcingid = userdetail.outsourcingid;
    this.getHubList();
    this.getUserList();
    this.getshipmentTypes();
    this.OutSourcingMasterId = userdetail.outsourcingid;
    //console.log('Mixin is working for :',result);
  },
  methods : {

    // changeDateFormat(){
    //   let current_datetime = new Date()
    //   console.log('date',format(new Date(), 'yyyy-MM-dd'));
    //   let formatted_date = current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + (current_datetime.getDate())).slice(-2);
    //   this.dateobj.toDate = formatted_date;
    //     console.log("this.dateobj.toDate==",this.dateobj.toDate);
    // },
    validateForm2(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(result) {
          this.SearchLoading = true;
          this.BatchArray = []
          this.NoBatchFlag = false
          this.isCapture = false
          let shipmentTypeObj = this.shipmentTypeList.find(shiptype => shiptype.businessconfig == this.shipmentType);

          let serchData = {
            "ShipmentType":shipmentTypeObj.shipType,
            "HubId": this.hubname,
            "DeliveryDate" :this.dateobj.toDate,
            "DeliveryUserID" : this.userID,
            "FileType" : this.fileType
          }

          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'expose/web/get/assignedbatchno',
              //'url':' https://lastmileallocationpod-apistage.xbees.in/expose/web/get/assignedbatchno',
              'data': serchData
          })
          .then(result => {
            if(result.data.code == 200){
              this.searchFlag = true
              this.BatchArray = result.data.data
              this.AssignBatchVal = this.BatchArray[0].AssignBatchNo;

            }else{
              this.searchFlag = false
              this.NoBatchFlag = true
            }
            this.SearchLoading = false;
          })
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getHubList(){
       axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubServiceCenterList =response.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })
    },
    getUserList(){
      this.users = []
      if (this.rolename.toLowerCase()=="agent" || this.userRolesFE.includes("agent")){
        let Emppayload = {
          "OutSourcingId": this.localuseroutsourcingid,
          "hubid": [this.hubname]
        }
        let apiendpoint = 'agenthandovershipments/getDeliveryUserName';
        if (keycloak.enableKavach) {
          apiendpoint = 'user/migration/getoutsourceuserlist';
        }
        axios.post(apiUrl.api_url + apiendpoint, {
            Emppayload
          })
          .then((response) => {

          if (response.data.code === 200) {
              this.DeliverySRList = response.data.data;
              $.each(response.data.data , (key,obj)=>{
                this.users.push({
                  value: `${obj.DeliveryUserId}`,
                  text: `${obj.FirstName} ${obj.LastName} (${obj.OldDeliveryUserOrUserId} - ${obj.DeliveryUserId}) - (${obj.MobileNumber})`
                })
              });
              if (!this.users.length){
                   this.$alertify.error("Delivery user not found");
              }
           }
            else {
              this.users = [];
                // this.$alertify.error("Delivery user not found");
            }
            this.srLoader='';
          })
          .catch(httpException => {
            this.$alertify.error("User details not found");
            console.error("exception is:::::::::", httpException);
          });
      }else {
       let payloadData = {"HubID":[this.hubname]}
       this.srLoader = this.loader;
       let apiendpoint = 'external/getremoteuserdetails/byhubid';
       if (keycloak.enableKavach) {
        apiendpoint = 'user/migration/getuserdetailsbyhubids';
       }
       axios.post(apiUrl.api_url + apiendpoint, payloadData)
        .then(async (response) => {
            if(response.data.code===200){
                //this.users = response.data.data.results;
                await response.data.data.results.map(userdata=>{
                  if (userdata.username != null){
                      //this.getDeliveryUname.push(userdata);
                      this.users.push({value:userdata.userid, text: `${userdata.FirstName} ${userdata.LastName} (${userdata.OldDeliveryUserOrUserId}) (${userdata.userid})`})
                  }
                })
            }
            else {
                this.users=[];
            }
            this.srLoader = '';
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })
      }
    },
    getdeliveyList(obj) {
      this.userObj = obj;
      this.userID = obj.value;
    },
    getshipmentTypes(){
       axios.post(apiUrl.api_url + 'external/businessconfig/get/list',{})
        .then((response) => {
            if(response.data.code===200){
                this.shipmentTypeList =response.data.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })
    },

    saveBatchImagePath(URL){
      return new Promise((resolve,reject) => {
        let batchData ={
  	      "DeliveryUserID" : this.userID,
          "DeliveryType" : this.fileType,
          "DeliveryDate" : this.dateobj.toDate,
          "CreatedBy" : this.localusermailid,
          "AssignBatchNo" :this.AssignBatchVal ,
          "ImagesPath" : URL,
          "HubId" :this.hubname ,
          "IsActive" : "1",
          "pageNo": this.AttachmentPageNo
         }

         axios.post(apiUrl.api_url + 'expose/web/put/addorupdatedetailsofscanpod', batchData)
          .then((response) => {
              if(response.data.code === 200){
                let TrackerInfo = {
                  projectname:"Last Mile",
                  type:"Web",
                  userid:this.localuserid,
                  username:this.localusermailid,
                  meta: {
                      "event":"uploadFile",
                      "HubId" : this.hubname,
                      "ImagesPath" : URL,
                      "AssignBatchNo" :this.AssignBatchVal,
                      "DeliveryUserID" : this.userID,
                      "DeliveryDate" :this.dateobj.toDate
                    }
                  }
                  this.PageTracker(TrackerInfo);
                resolve({"code":200,"message":"uploaded Successfully"})
               //this.$alertify.success('uploaded Successfully');

              } else {
                resolve({"code":200,"message":"Upload Failed"});
                //this.$alertify.error("Upload Failed");
              }
          })
          .catch((httpException) => {
              this.scanShipmentBatchFlag = false;
              this.$alertify.error("Unable to upload file");
              console.error('exception is:::::::::', httpException)
          })
        })
    },
    uploadFile(event){
      const formData = new FormData();
      formData.append('FileType',this.fileType);
      formData.append('HubID',this.hubname);
      formData.append('DeliveryUserID',this.userID);
      formData.append('BatchId',this.AssignBatchVal);
      formData.append('file',this.file);
      this.validated = true;
        //for upload file image

        //let FilterExtention = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png"];
        let FilterExtention = ["image/jpeg", "image/jpg","image/png"];

          if(this.file.size >= 1024 * 1024 * 10){
            this.validated = true;
            this.$alertify.error("Please check image size should be less than 10MB ");
            const input = this.$refs.uploadfile;
            input.type = 'text';
            input.type = 'file';
            this.validated = true;
            this.Loading = false;
          }else {

            console.log('formData==',formData);

              if(!FilterExtention.includes(this.file.type)){
                this.$alertify.error("Please select image to upload");
              }else{
              this.uploadLoader = true;
              axios.post(apiUrl.api_url + 'ScanPOD/ScanPODSheetUpload', formData)
               .then(async (response) => {
                   if(response.data.code === 200){
                     let PromiseResult = await this.saveBatchImagePath(response.data.imageUrl);
                     if(PromiseResult.code == 200){
                       this.$alertify.success(PromiseResult.message);
                     } else {
                       this.$alertify.success(PromiseResult.message);
                     }
                     this.removeFile();
                   } else if(response.data.code === 202){
                     this.$alertify.error('Upload failed');
                   } else {
                     this.$alertify.error(response.data.message);
                   }
                   this.uploadLoader = false;
               })
               .catch((httpException) => {
                   this.scanShipmentBatchFlag = false;
                   this.$alertify.error("Unable to upload file");
                   console.error('exception is:::::::::', httpException)
              })
            }
          }
    },

    onuploadChange(event){
      this.isCapture = false
      this.isVideo = false
      this.video = this.$refs.video;
      const file = event.target.files[0];
      this.file = file;
      this.Loading = true;
      this.validated = false;
      //image upload code start here
    },
    removeFile(){
      this.isVideo = false
      this.isCapture = false
      this.file = ''
      this.video = this.$refs.video;
      const input = this.$refs.uploadfile;
      input.type = 'text';
      input.type = 'file';
      this.validated = true
    },
    clearAll(){
      this.isCapture = false
      this.$validator.reset();
      this.errors.clear();
      this.searchFlag = false
      this.NoBatchFlag = false
      this.shipmentType = ''
      this.dateobj.toDate = ''
      this.fileType =''
      this.userID =''
      this.isVideo = false
      this.removeFile()
    },

    captureImage(){
      const input = this.$refs.uploadfile;
      input.type = 'text';
      input.type = 'file';
      this.validated = true

      this.isCapture = true
      this.isVideo = true
      this.video = this.$refs.video;
      if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
              this.video.srcObject = stream;
              this.video.play();
          });
      }
    },
    capture() {

       this.captures = []
       //this.removeFile()
       this.isCapture = true
       this.isVideo = true
       this.canvas = this.$refs.canvas;
       var context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 440, 280);
       this.captures.push(this.canvas.toDataURL("image/jpeg"));

       //this.file = this.canvas.toDataURL("image/png")

       var ImageURL = this.canvas.toDataURL("image/jpeg")
       // Split the base64 string in data and contentType
        var block = ImageURL.split(";");
        // Get the content type of the image
        var contentType = block[0].split(":")[1];// In this case "image/gif"
        // get the real base64 content of the file
        var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

        // Convert it to a blob to upload
        var blob = this.b64toBlob(realData, contentType);
        this.file = blob
    },

  b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
              }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, {type: contentType});
            var filename = "image.jpeg"
            //var File = new Blob([byteArrays], filename, {type: contentType, lastModified: Date.now()});
            var file = new File([blob], filename, {type: contentType, lastModified: Date.now()});
            return file;
          },

          setFileType(e){
            let selectedShipType = $("#shipmentType option:selected").text();
            this.fileTypeArray = [];
            this.fileType = '';
            if(selectedShipType == 'eComm-Reverse-PickUp'){
              this.fileTypeArray.push('DTOWHHandover');
            } else {
              this.fileTypeArray.push('Delivery','WHHandover');
            }
          },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ScanPODSheet/UploadScanPODSheet/UploadScanPODSheet.component.js